import React, { PureComponent } from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import SwapSummary from './SwapSummary'
import SwapManagement from './SwapManagement'
import ItemsICanGetModal from './ItemsICanGetModal'
import ItemsICanGiveModal from './ItemsICanGiveModal'
import { themeColors } from '../../styles/theme'
import AddMoneyModal from './AddMoneyModal'
import {
  getSwapForMe,
  getSwapForYou,
  isProponente,
  isDestinatario,
} from '../../utils'

class Swap extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      modalItemsICanGetOpen: false,
      modalItemsICanGiveOpen: false,
      modalAddMoneyOpen: false,
      modalConfirmSwapOpen: false,
    }
  }

  toggleModalItemsICanGetOpen = () => {
    this.setState(state => ({
      modalItemsICanGetOpen: !state.modalItemsICanGetOpen,
    }))
  }

  toggleModalItemsICanGiveOpen = () => {
    this.setState(state => ({
      modalItemsICanGiveOpen: !state.modalItemsICanGiveOpen,
    }))
  }

  toggleModalAddMoneyOpen = () => {
    this.setState(state => ({ modalAddMoneyOpen: !state.modalAddMoneyOpen }))
  }

  toggleModalConfirmSwapOpen = () => {
    this.setState(state => ({
      modalConfirmSwapOpen: !state.modalConfirmSwapOpen,
    }))
  }

  clearMoneyProponente = () => {
    this.props.setMoneyProponente(0)
  }

  clearMoneyDestinatario = () => {
    this.props.setMoneyDestinatario(0)
  }

  render() {
    const {
      editable,
      user,
      swap,
      setMoneyProponente,
      addItemDestinatario,
      removeItemDestinatario,
      addItemProponente,
      removeItemProponente,
      performingAction,
      onSwap,
      onAcceptClick,
      onRejectClick,
      onCancelClick,
      onEditClick,
      onUndoEditClick,
      onFeedbackClick,
      onMessageClick,
      onArchiveClick,
    } = this.props

    const swapForMe = getSwapForMe(swap, user)
    const swapForYou = getSwapForYou(swap, user)

    const userAsProponente = isProponente(swap, user)
    const userAsDestinatario = isDestinatario(swap, user)

    return (
      <div>
        <SwapSummary
          editable={editable}
          swap={swap}
          user={user}
          performingAction={performingAction}
          onSwap={this.toggleModalConfirmSwapOpen}
          onAcceptClick={onAcceptClick}
          onRejectClick={onRejectClick}
          onCancelClick={onCancelClick}
          onEditClick={onEditClick}
          onUndoEditClick={onUndoEditClick}
          onFeedbackClick={onFeedbackClick}
          onMessageClick={onMessageClick}
          onArchiveClick={onArchiveClick}
        />
        <SwapManagement
          editable={editable}
          swap={swap}
          user={user}
          onClickProponenteAddItems={
            userAsProponente
              ? this.toggleModalItemsICanGiveOpen
              : this.toggleModalItemsICanGetOpen
          }
          onClickDestinatarioAddItems={
            userAsProponente
              ? this.toggleModalItemsICanGetOpen
              : this.toggleModalItemsICanGiveOpen
          }
          onProponenteItemRemoved={removeItemProponente}
          onDestinatarioItemRemoved={removeItemDestinatario}
          onProponenteAddMoney={this.toggleModalAddMoneyOpen}
          onProponenteClearMoney={this.clearMoneyProponente}
          onDestinatarioClearMoney={this.clearMoneyDestinatario}
        />
        <AddMoneyModal
          initialMoney={swapForMe.money}
          onMoneyAdded={setMoneyProponente}
          open={this.state.modalAddMoneyOpen}
          onRequestClose={this.toggleModalAddMoneyOpen}
        />
        <ItemsICanGetModal
          addItem={userAsProponente ? addItemDestinatario : addItemProponente}
          removeItem={
            userAsProponente ? removeItemDestinatario : removeItemProponente
          }
          choosedItemsById={swapForYou.itemsData}
          swapId={swap.id}
          swapperId={swapForYou.user.id}
          open={this.state.modalItemsICanGetOpen}
          onRequestClose={this.toggleModalItemsICanGetOpen}
        />
        <ItemsICanGiveModal
          addItem={userAsDestinatario ? addItemDestinatario : addItemProponente}
          removeItem={
            userAsDestinatario ? removeItemDestinatario : removeItemProponente
          }
          choosedItemsById={swapForMe.itemsData}
          swapId={swap.id}
          swapperId={swapForYou.user.id}
          open={this.state.modalItemsICanGiveOpen}
          onRequestClose={this.toggleModalItemsICanGiveOpen}
        />
        <Dialog
          title="Conferma proposta"
          titleStyle={{ backgroundColor: themeColors.lightBackground }}
          modal={false}
          open={this.state.modalConfirmSwapOpen}
          onRequestClose={this.toggleModalConfirmSwapOpen}
          actions={[
            <FlatButton
              label="Annulla"
              primary={true}
              onClick={this.toggleModalConfirmSwapOpen}
            />,
            <FlatButton
              label="Ok"
              primary={true}
              keyboardFocused={true}
              onClick={() => {
                this.toggleModalConfirmSwapOpen()
                onSwap()
              }}
            />,
          ]}>
          <p>Confermi la proposta?</p>
        </Dialog>
      </div>
    )
  }
}

export default Swap



// WEBPACK FOOTER //
// ./src/common/Swap/Swap.js